import {
    Grid2 as Grid,
} from '@mui/material';
import React, {
    useContext,
    useEffect,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { Descriptions } from '../../constants/Descriptions';
import {
    MCO_THEME,
    POL_THEME,
    ThemeContext,
} from '../../constants/theme.ts';
import { Titles } from '../../constants/titles';
import { AppContext } from '../../contexts/AppContext';
import * as routes from '../../constants/routes';

const MassTimesUpdateForm = () => {
    const themeContext = useContext(ThemeContext);
    const {
        setPageTitle,
        setPageDescription,
    } = useContext(AppContext);
    const history = useNavigate();

    useEffect(() => {
        switch (themeContext) {
            case MCO_THEME:
                history(routes.ERROR_404);
                break;
            case POL_THEME:
                setPageTitle(Titles.POL_MASSTIME_UPDATE_FORM);
                setPageDescription(Descriptions.POL_MASSTIME_UPDATE_FORM);
                break;
            default:
                history(routes.ERROR_404);
                break;
        }
    }, [history, themeContext, setPageTitle, setPageDescription]);

    return (
        <Grid
            container
            sx={{
                justifyContent: 'center',
            }}
        >
            <Grid
                size={{
                    xs: 11,
                    sm: 10,
                    md: 6,
                }}
                sx={{
                    textAlign: 'center',
                }}
            >
                <h1>
                    Request a Mass Times Update
                </h1>
                <iframe
                    title="MassTimes - Find a Catholic Mass - Home Form"
                    src="https://form.jotform.com/250864757236163"
                    width="100%"
                    height="1200"
                    style={{
                        backgroundColor: 'transparent',
                        border: '0',
                        marginLeft: 'auto',
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default MassTimesUpdateForm;
